import React, { Component, Fragment } from "react";
import withRoute from "../../withRouter/withRouter";
import { toPersianNumber } from "../../../classes/utils";
import "./Ticket.css";

class Ticket extends Component {
    constructor(props) {
        super(props);

        this.send_message = this.send_message.bind(this);
    }

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        let { ticket, order } = this.state;
        if (!ticket) {
            this.request_data();
        }
    }

    on_page_change(page) {
        this.setState({ page });
    }

    request_data() {
        let { toast, connection, router } = this.props;
        let { filters, page, count } = this.state;
        filters = filters || {};
        filters.id = router.params.id;
        filters.setRead = true;
        connection
            .get_filtered_data("tickets", filters, null, count, null, page)
            .then((res) => {
                let ticket = res.data.tickets[0];
                this.setState({ ticket });

                ticket.subject != "other" &&
                    connection
                        .get_filtered_data("orders", { id: ticket.subject })
                        .then((res) => {
                            let order = res.data.orders[0];
                            console.log(order);
                            this.setState({ order });
                        })
                        .catch((err) => {
                            toast(
                                "خطا در دریافت تیکت ",
                                " خطای : " + err,
                                " danger"
                            );
                        });
            })
            .catch((err) => {
                toast("خطا در دریافت تیکت ", " خطای : " + err, " danger");
            });
    }

    send_message() {
        this.state.ticket &&
            this.props.connection
                .append_message_to_ticket(this.state.ticket.id, {
                    message: this.message,
                    time: Date.now(),
                })
                .then((res) => {
                    let { ticket } = this.state;
                    ticket.messages = res.data.messages;
                    this.setState({ ticket });
                })
                .catch((err) => {
                    this.props.toast(
                        "خطا در ارسال پیام",
                        "پیام ارسال نشد :  " + err,
                        " danger"
                    );
                });
    }

    message = "";

    state = {
        order: null,
        ticket: null,
        attachmentToShow: null,
    };
    render() {
        let { ticket, order, attachmentToShow } = this.state;
        let { messages, costumerName, costumerID, orderID, subject } =
            ticket || {};
        let { items } = order || {};
        let j = 0;
        return (
            <div className="TicketComponentContainer">
                {attachmentToShow && (
                    <div
                        className="maximize"
                        onClick={(ev) =>
                            this.setState({ attachmentToShow: null })
                        }
                    >
                        {attachmentToShow.type === "image" ? (
                            <img src={attachmentToShow.url} />
                        ) : (
                            <video
                                src={attachmentToShow.url}
                                autoPlay={false}
                            ></video>
                        )}
                    </div>
                )}
                <div className="order">
                    {order && (
                        <Fragment>
                            <div className="caption">سفارش مورد نظر</div>
                            <div className="orderItems">
                                {items &&
                                    items.length > 0 &&
                                    items.map((item, index) => {
                                        return (
                                            <div
                                                className="item "
                                                key={item.id}
                                            >
                                                <a
                                                    className="name text primary"
                                                    href={"/items/" + item.id}
                                                >
                                                    {item.name}
                                                </a>
                                                <div className="amount text info">
                                                    {toPersianNumber(
                                                        item.amount
                                                    )}
                                                    {item.unit}
                                                </div>
                                                <div className="fee text secondary">
                                                    {toPersianNumber(
                                                        order.check[index]
                                                            .price,
                                                        true
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                            <div className="showOrder btn info">
                                <a href={"/orders/" + order.orderId}>
                                    مشاهده کامل سفارش
                                </a>
                            </div>
                        </Fragment>
                    )}
                </div>

                <div className="messageBox">
                    <div className="subject text primary">
                        {subject === "other"
                            ? "متفرقه"
                            : "سفارش شماره : " + subject}
                    </div>
                    <div className="messages">
                        {messages &&
                            messages.length > 0 &&
                            messages.map((m) => {
                                return (
                                    <div
                                        className={"message " + m.poster}
                                        key={j++}
                                    >
                                        <div className="message">
                                            {m.message}
                                        </div>
                                        <div className="attachments">
                                            {m.attachments &&
                                                m.attachments.map((a) => {
                                                    return (
                                                        <div
                                                            className="attachment"
                                                            key={j++}
                                                            onClick={(ev) => {
                                                                this.setState({
                                                                    attachmentToShow:
                                                                        a,
                                                                });
                                                            }}
                                                        >
                                                            {a.type ===
                                                            "image" ? (
                                                                <img
                                                                    src={a.url}
                                                                />
                                                            ) : (
                                                                <video
                                                                    src={a.url}
                                                                    autoPlay={
                                                                        false
                                                                    }
                                                                ></video>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                        <div className="time text info">
                                            {new Date(m.time).toLocaleString(
                                                "fa-IR"
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                    <div className="writeMessage">
                        {/* <div className="attach ">
                            <button className="btn thirdary">
                                <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <input
                                type="file"
                                name="attachment"
                                multiple={true}
                                className="attachments "
                            />
                        </div> */}
                        <input
                            type="text"
                            name="message"
                            placeholder="پاسخ خود را بنویسید"
                            className="message"
                            onChange={(ev) => (this.message = ev.target.value)}
                        />
                        <button
                            className="btn confirm btn-sm text-white"
                            onClick={this.send_message}
                        >
                           ارسال
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRoute(Ticket);
